module.exports = __webpack_public_path__ + "img/address_over_area.0a5331dd.png";